import { render, staticRenderFns } from "./AssetsPreview.vue?vue&type=template&id=186b90d1&"
import script from "./AssetsPreview.vue?vue&type=script&lang=js&"
export * from "./AssetsPreview.vue?vue&type=script&lang=js&"
import style0 from "./AssetsPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports